import { ClientPurchaseState } from '@bd/client/types'

export const state: ClientPurchaseState = {
  purchaseOffer: undefined,
  purchaseMessage: undefined,
  error: undefined,
}
